import { useEffect, useMemo } from 'react';
import qs from 'qs';
import { CUSTOM_CATEGORIES } from 'utils/constants/casino/custom-categories';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { isMobile } from 'utils/is-mobile';
import { useCustomHistory } from 'newhooks/generic/useCustomHistory';
import { ConstantsCasino } from '../constants';
import { UtilsCasino } from '../GameViewContainer/utils';

export const useCsOldRouteChecker = () => {
  const { history } = useCustomHistory();

  const routeLength = useMemo(
    () => UtilsCasino.getRouteLength(),
    [history.location?.search, history.location?.pathname]
  );

  /**  redirect to casino new url if user navigated with old game structured link  **/
  useEffect(() => {
    const searchObject = {
      ...qs.parse(window.location.search, {
        ignoreQueryPrefix: true
      })
    };

    const path = window.getPathname();

    if (
      !searchObject.preview &&
      path.includes(`/${SpringConfigs.CASINO_MOUNT_PATH}/`) &&
      !path.includes(`/${CUSTOM_CATEGORIES.all.id}/`) &&
      routeLength
    ) {
      const pathFromMountPoint = path.split(
        `/${SpringConfigs.CASINO_MOUNT_PATH}/`
      )[1];

      const segmentsLength = pathFromMountPoint.split('/').length;

      const OLD_ROUTE_LENGTH =
        routeLength === ConstantsCasino.ROUTE_LENGTH_WITHOUT_PROVIDER - 1
          ? 2
          : ConstantsCasino.OLD_ROUTE_DEFAULT_LENGTH;

      if (
        (isMobile() &&
          routeLength === ConstantsCasino.ROUTE_LENGTH_WITHOUT_PROVIDER - 1 &&
          segmentsLength === OLD_ROUTE_LENGTH) ||
        (routeLength !== ConstantsCasino.ROUTE_LENGTH_WITHOUT_PROVIDER - 1 &&
          segmentsLength === OLD_ROUTE_LENGTH)
      ) {
        const position = path.indexOf(pathFromMountPoint);
        const res = [
          path.slice(0, position),
          `${CUSTOM_CATEGORIES.all.id}/`,
          path.slice(position)
        ].join('');

        history.push({
          pathname: res,
          search: qs.stringify(
            qs.parse(window.location.search, { ignoreQueryPrefix: true })
          )
        });
      }
    }
  }, [routeLength]);
};
